import Vue from 'vue';
import { toLocal, toCookie } from './storages';

const store = {
    token: undefined,
    user: undefined
};

toCookie(store, {
    attrs: ['token']
});

const state = Vue.observable(store);

const actions = {
    setToken(token) {
        state.token = token;
    },
    setUser(user) {
        state.user = user;
    },
    resetAuth() {
        actions.setToken(undefined);
        actions.setUser(undefined);
    }
};

export {
    state,
    actions
};